import {
  ADD_ACCOUNT_TO_MOTION,
  ADD_ACCOUNT_TO_MOTION_SUCCESS,
  DATA_FAILED,
} from "../actions/AccountAction";

const initialState = {
  isLoading: true,
  errMess: null,
  params: {},
};

const AccountReducer = function (state = initialState, action) {
  switch (action.type) {
    case ADD_ACCOUNT_TO_MOTION:
      return {
        ...state,
        isLoading: true,
        errMess: null,
      };
    case ADD_ACCOUNT_TO_MOTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
      };
    case DATA_FAILED:
      return { ...state, isLoading: false, errMess: action.payload };
    default:
      return state;
  }
};

export default AccountReducer;
